import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { BaseGoogleAnalyticsCategory } from '../../base-google-analytics-category';

enum SearchResultsAction {
  LOCK = 'lock',
  CLEAR = 'clear',
  FACET_SEARCH = 'facet_search',
  FACET_RESET = 'facet_reset',
  RESULT_LIST_MODE = 'result_list_mode',
  SORT = 'sort',
  IMAGE_DIALOG = 'image_dialog'
}

export class SearchResults extends BaseGoogleAnalyticsCategory {
  constructor(ga: GoogleAnalyticsService, isEnabled: boolean) {
    super(ga, 'catalog_search_results', isEnabled);
  }

  public lock(): void {
    this.event(SearchResultsAction.LOCK);
  }

  public clear(): void {
    this.event(SearchResultsAction.CLEAR);
  }

  public facetSearch(solrQuery: string): void {
    this.event(SearchResultsAction.FACET_SEARCH, solrQuery);
  }

  public facetReset(): void {
    this.event(SearchResultsAction.FACET_RESET);
  }

  public resultListMode(key: string): void {
    this.event(SearchResultsAction.RESULT_LIST_MODE, key);
  }

  public sort(sortParams: string): void {
    this.event(SearchResultsAction.SORT, sortParams);
  }

  public imageDialog(id: string): void {
    this.event(SearchResultsAction.IMAGE_DIALOG, id);
  }
}
